<template>
    <div style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">

        <el-form ref="form2" :model="form2" label-width="180px">
            <el-form-item label="银盛通道" class="grid-content bg-purple-dark">
            </el-form-item>
            <el-form-item label="经营类目：">{{jy_lm_ys}}</el-form-item>
            <el-form-item label="结算费率(%)：">{{rate_ys}}</el-form-item>
            <el-form-item label="商家协议："><div v-if="merchant_agreement !== ''" ><img :src= "getImgUrl33()" style="width: 300px;height: 200px;  "/></div></el-form-item>
        </el-form>

        <el-form ref="form3" :model="form3" label-width="180px">
            <el-form-item label="进件状态" class="grid-content bg-purple-dark">
            </el-form-item>
            <el-form-item label="进件时间："></el-form-item>
            <el-form-item label="微信费率："></el-form-item>
            <el-form-item label="支付宝费率："></el-form-item>
            <el-form-item label="商户编号："></el-form-item>
            <el-form-item label="注册名称："></el-form-item>
            <el-form-item label="进件状态："></el-form-item>
            <el-form-item label="进件结果："></el-form-item>
        </el-form>

    </div>

</template>
<style>

    .bg-purple-dark {
        background: #e5e9f2;
    }
</style>
<script>
import * as agentService from '@/api/sys/agent'
import util from '@/libs/util.js'
export default {
  name: 'child5',
  props: ['agentid_f5'],
  components: { },
  data () {
    return {
      jy_lm_ys: '',
      rate_ys: '',
      merchant_agreement: '',
      loading: false,
      oneagent: {},
      form2: {},
      form3: {},
      editFormVisible: false
    }
  },
  mounted () {
    this.getTableData()
  },
  methods: {
    getImgUrl33 () {
      return 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + this.merchant_agreement
    },
    getTableData () {
      var formData4 = new FormData() // 声明一个FormData对象
      formData4.append('agentid', this.agentid_f5)
      agentService.getPerfectAgent(formData4).then(data => {
        if (data != null && data != '') {
          this.jy_lm_ys = data.jy_lm_ys
          this.rate_ys = data.rate_ys
          this.merchant_agreement = data.merchant_agreement
        }
      })
    }
  }
}
</script>
